import * as React from "react";
import { SVGProps } from "react";
export const ExclamationTriangleIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M2.354 17.5C2.02067 17.5 1.76734 17.354 1.594 17.062C1.42 16.7707 1.41634 16.4793 1.583 16.188L9.25 2.97899C9.41667 2.68766 9.66667 2.54199 10 2.54199C10.3333 2.54199 10.5833 2.68766 10.75 2.97899L18.417 16.188C18.5837 16.4793 18.58 16.7707 18.406 17.062C18.2327 17.354 17.9793 17.5 17.646 17.5H2.354ZM10.021 8.35399C9.785 8.35399 9.58 8.44099 9.406 8.61499C9.23267 8.78833 9.146 8.99299 9.146 9.22899V11.562C9.146 11.7987 9.23267 12.0037 9.406 12.177C9.58 12.351 9.785 12.438 10.021 12.438C10.257 12.438 10.4617 12.351 10.635 12.177C10.809 12.0037 10.896 11.7987 10.896 11.562V9.22899C10.896 8.99299 10.809 8.78833 10.635 8.61499C10.4617 8.44099 10.257 8.35399 10.021 8.35399ZM10.021 15C10.257 15 10.4617 14.9133 10.635 14.74C10.809 14.566 10.896 14.361 10.896 14.125C10.896 13.889 10.809 13.684 10.635 13.51C10.4617 13.3367 10.257 13.25 10.021 13.25C9.785 13.25 9.58 13.3367 9.406 13.51C9.23267 13.684 9.146 13.889 9.146 14.125C9.146 14.361 9.23267 14.566 9.406 14.74C9.58 14.9133 9.785 15 10.021 15ZM3.854 15.75H16.146L10 5.16699L3.854 15.75Z"
            fill="currentColor"
        />
    </svg>
);
ExclamationTriangleIcon.displayName = "ExclamationTriangleIcon";
